<template>
  <CCard class="my-5 p-5 card-container">
    <CContainer>
      <CRow class="mb-2 w-70">
        <h2 class="font-weight-bold mb-2">
          {{ $t('automation.new.card.title') }}
        </h2>
        <p class="text-gray-700">
          {{ $t('automation.new.card.description') }}
        </p>
      </CRow>
      <div v-if="loadingAudienceSchema" class="d-flex justify-content-center align-items-center">
        <CSpinner style="width: 4rem; height: 4rem" />
      </div>
      <div v-else>
        <CRow>
          <CAlert v-if="showDateFieldAlert" color="purple-200" class="d-flex align-items-center w-100">
            <CIcon class="text-primary" name="notificationAlert" :height="32" viewBox="0 0 32 32" />
            <CCol sm="8" class="my-2">
              <h2 class="font-lg mb-1 text-primary">{{ $t('automation.new.card.missing.title') }}</h2>
              <p class="font-md m-0 text-primary">{{ $t('automation.new.card.missing.description') }}</p>
            </CCol>
            <CCol class="text-right">
              <CButton @click="redirectToAudience" color="primary">{{ $t('automation.new.card.missing.button') }}</CButton>
            </CCol>
          </CAlert>
        </CRow>
        <CRow class="d-flex justify-content-center">
          <AutomationNewCardOption
            v-for="option in cardOptions"
            :optionTitle="option.title"
            :optionDescription="option.description"
            :optionRouteName="option.routeRedirectName"
            :hasBadge="option.hasBadge"
            :isOptionDisabled="showDateFieldAlert || option.disabled"
          />
        </CRow>
      </div>
    </CContainer>
  </CCard>
</template>

<script>
import { getSchema, FIELD_TYPES } from '@/utils/audienceSchema'
import AutomationNewCardOption from '../components/AutomationNewCardOption.vue'

export default {
  name: 'AutomationNew',
  components: { AutomationNewCardOption },
  data() {
    return {
      audienceSchema: null,
      showDateFieldAlert: false,
      loadingAudienceSchema: true,
    }
  },
  mounted() {
    this.getAudienceSchema()
  },
  computed: {
    cardOptions() {
      return [
        {
          
          title: this.$t('automation.new.card.option-1.title'),
          description: this.$t('automation.new.card.option-1.description'),
          hasBadge: false,
          disabled: false,
          routeRedirectName: "automationDate"
        },
        /* {
          title: this.$t('automation.new.card.option-2.title'),
          description: this.$t('automation.new.card.option-2.description'),
          hasBadge: true,
          disabled: true
        },
        {
          title: this.$t('automation.new.card.option-3.title'),
          description: this.$t('automation.new.card.option-3.description'),
          hasBadge: true,
          disabled: true
        } */
      ]
    },
    hasAnyDateField() {
      if (!this.audienceSchema) return

      return this.audienceSchema.some((schema) => {
        const dateFieldCondition = schema.dataType.key == FIELD_TYPES.DATE
        const dateTimeFieldCondition = schema.dataType.key == FIELD_TYPES.DATETIME
        return dateFieldCondition || dateTimeFieldCondition
      })
    },
  },
  methods: {
    redirectToAudience() {
      this.$router.push({ name: 'audience' })
    },
    async getAudienceSchema() {
      try {
        this.loadingAudienceSchema = true
        const organizationId = this.$route.params.organizationId
        this.audienceSchema = await getSchema(organizationId)
        if (this.audienceSchema && this.hasAnyDateField) return
        this.showDateFieldAlert = true
      } finally {
        this.loadingAudienceSchema = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  max-width: 700px;
  margin: auto;
}
</style>
